import React, { FC, useEffect, useState } from 'react';
import { useSignStore } from './hooks';
import { Button, Grid, TextField, TextFieldProps } from '@material-ui/core';
import { CaptchaGetResult } from 'core/stores/SignStore';

interface Props {
  error: boolean;
  setErrorCaptcha: (i: boolean) => void;
  captchaValue: string;
  setCaptchaValue: (value: string) => void;
}

const Captcha: FC<Props> = ({ error, captchaValue, setCaptchaValue, setErrorCaptcha }) => {
  const { captchaGet, imageBase64, captchaVerify } = useSignStore();

  const [image, setImage] = useState<string>('');

  const handleChangeCaptchaValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCaptchaValue(e.target.value);
  };

  const handleClearCaptchaValue = () => {
    setCaptchaValue('');
  };

  useEffect(() => {
    captchaGet();
  }, []);

  useEffect(() => {
    if (error) {
      captchaGet();
    }
  }, [error]);

  useEffect(() => {
    if (imageBase64) {
      setImage(imageBase64);
    }
  }, [imageBase64]);
  return (
    <Grid style={{ marginBottom: 20, marginTop: 10, width: '100%' }}>
      <TextField
        placeholder="Введите символы с картинки"
        value={captchaValue}
        fullWidth
        error={error}
        helperText={error && 'Код введен неверно. Попробуйте еще раз'}
        onChange={handleChangeCaptchaValue}
        style={{
          marginBottom: error ? 0 : 15,
          width: '100%',
        }}
      />
      <Grid
        direction="row"
        justify="space-between"
        wrap="nowrap"
        alignItems="center"
        alignContent="center"
        style={{ display: 'flex', padding: '0 5px' }}
      >
        {image && <img height={70} src={image} />}
        <Button
          color="primary"
          style={{ textDecoration: 'none', fontWeight: 400, fontSize: 16, width: '100%' }}
          onClick={() => {
            handleClearCaptchaValue();
            setErrorCaptcha(false);
            captchaGet();
          }}
        >
          Обновить
        </Button>
      </Grid>
    </Grid>
  );
};

export default Captcha;
